import React, {useState} from 'react'
import {useInterval} from '../utils/time'
import Icons from '../components/Icons'
import {_L, useLocaleState} from '../context/LocaleContext'
import styled from 'styled-components'
import Button from '../components/Button/Button'
import {Layer} from 'grommet'

const TimeoutMessage = ({continueWorking}) => {
  const localeState = useLocaleState()
  return (
    <StyledLayer position="center">
      <TimeoutContainer>
        <TimeoutTextContainer>
          <Icons icon="TIMER" />
          <TimeoutTitle>
            {_L({key: 'Do you want more time?', localeState})}
          </TimeoutTitle>
        </TimeoutTextContainer>
        <TimeoutButton
          onClick={continueWorking}
          label={_L({key: 'Continue working', localeState})}
        />
      </TimeoutContainer>
    </StyledLayer>
  )
}

export const useKioskTimer = ({
  enable = false,
  inUseDelay,
  timeoutDelay,
  timeoutExpirationHandler
}) => {
  const [delay, setDelay] = useState(inUseDelay)
  const [timeoutInterval, setTimeoutInterval] = useState(null)
  const [showContinueWorking, setShowContinueWorking] = useState(false)

  const onClickHandler = () => {
    let newDelay = delay === inUseDelay ? inUseDelay + 1 : inUseDelay
    setDelay(newDelay)
  }

  const continueWorking = () => {
    let newDelay = delay === inUseDelay ? inUseDelay + 1 : inUseDelay
    setDelay(newDelay)
    setTimeoutInterval(null)
    setShowContinueWorking(false)
  }

  const activeIntervalExpired = () => {
    setShowContinueWorking(true)
    setTimeoutInterval(timeoutDelay)
  }

  const timeOutExpired = () => {
    setTimeoutInterval(null)
    setShowContinueWorking(false)
    if (timeoutExpirationHandler) {
      timeoutExpirationHandler()
    }
  }

  // In-use interval
  useInterval(activeIntervalExpired, enable ? delay : null)

  // Timeout interval starts when the in-use interval expires
  useInterval(timeOutExpired, timeoutInterval)

  return {
    message: showContinueWorking ? (
      <TimeoutMessage continueWorking={continueWorking} />
    ) : null,
    onClickHandler
  }
}

const TimeoutContainer = styled.div`
  width: 588px;
  height: 388px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #282d41;
  border-radius: 6px;
  
  @media (max-width: 420px) {
    width: 300px;
  }
`

const TimeoutTextContainer = styled.div`
  margin-top: 60px;
  text-align: center;
  width: 300px;
  
  @media (max-width: 420px) {
    width: 260px;
  }
`
const TimeoutTitle = styled.div`
  padding-top: 60px;
  font-size: 25px;
  font-weight: 600;
  letter-spacing: -0.4px;
  color: white;
  
  @media (max-width: 420px) {
    font-size: 18px;
  }
`

const TimeoutButton = styled(Button)`
  width: 100%;
  height: 72px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  text-align: center;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  
  @media (max-width: 420px) {
    font-size: 14px;
  }
`

const StyledLayer = styled(Layer)`
  border-radius: 6px
`
